import { render, staticRenderFns } from "./DepartManage.vue?vue&type=template&id=cd25758e&scoped=true"
import script from "./DepartManage.vue?vue&type=script&lang=ts"
export * from "./DepartManage.vue?vue&type=script&lang=ts"
import style0 from "./DepartManage.vue?vue&type=style&index=0&id=cd25758e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd25758e",
  null
  
)

export default component.exports